export var FileLogging = true;
export var ConsoleLogging = true;